<template>
    <form
        class="modal-card newsletter-view newsletter-details-form"
        @submit.prevent="sendForm()"
    >
        <div class="modal-card-head">
            <h1 class="modal-card-title">
                {{ $t('footer.newsletter.label') }}
            </h1>
            <button type="button" class="delete" @click="$parent.close()" />
        </div>
        <div class="modal-card-body has-background-light">
            <div class="columns is-multiline">
                <div class="column is-full-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3"
                            >{{
                                $t('footer.newsletter.inputLabels.salutation')
                            }}
                            *</label
                        >
                        <div class="control">
                            <input
                                v-model="contactDetails.salutation"
                                class="input"
                                type="text"
                                maxlength="20"
                                :placeholder="
                                    $t(
                                        'footer.newsletter.inputLabels.salutation'
                                    )
                                "
                                required
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-half-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3">{{
                            $t('footer.newsletter.inputLabels.firstname')
                        }}</label>
                        <div class="control">
                            <input
                                v-model="contactDetails.firstName"
                                class="input"
                                type="text"
                                maxlength="20"
                                :placeholder="
                                    $t(
                                        'footer.newsletter.inputLabels.firstname'
                                    )
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-half-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3"
                            >{{
                                $t('footer.newsletter.inputLabels.lastname')
                            }}
                            *</label
                        >
                        <div class="control">
                            <input
                                v-model="contactDetails.lastName"
                                class="input"
                                type="text"
                                maxlength="20"
                                :placeholder="
                                    $t('footer.newsletter.inputLabels.lastname')
                                "
                                required
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-full-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3"
                            >{{
                                $t('footer.newsletter.inputLabels.email')
                            }}
                            *</label
                        >
                        <div class="control">
                            <input
                                v-model="mail"
                                class="input"
                                type="email"
                                :placeholder="
                                    $t('footer.newsletter.inputLabels.email')
                                "
                                required
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-full-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3">{{
                            $t('footer.newsletter.inputLabels.company')
                        }}</label>
                        <div class="control">
                            <input
                                v-model="contactDetails.firm"
                                class="input"
                                type="text"
                                :placeholder="
                                    $t('footer.newsletter.inputLabels.company')
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-full-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3">{{
                            $t('footer.newsletter.inputLabels.address')
                        }}</label>
                        <div class="control">
                            <input
                                v-model="contactDetails.street"
                                class="input"
                                type="text"
                                :placeholder="
                                    $t('footer.newsletter.inputLabels.address')
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-half-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3">{{
                            $t('footer.newsletter.inputLabels.postalCode')
                        }}</label>
                        <div class="control">
                            <input
                                v-model="contactDetails.plz"
                                class="input"
                                type="number"
                                :placeholder="
                                    $t(
                                        'footer.newsletter.inputLabels.postalCode'
                                    )
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-half-tablet">
                    <div class="field">
                        <label class="label is-uppercase mt-3 ml-3">{{
                            $t('footer.newsletter.inputLabels.city')
                        }}</label>
                        <div class="control">
                            <input
                                v-model="contactDetails.location"
                                class="input"
                                type="text"
                                :placeholder="
                                    $t('footer.newsletter.inputLabels.city')
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="has-checkbox">
                        <label class="checkbox">
                            <input
                                class="control"
                                type="checkbox"
                                v-model="contactDetails.confirmation"
                            />
                            {{
                                $t(
                                    'footer.newsletter.inputLabels.privacyStatementCheckbox'
                                )
                            }}
                            <RouterLink
                                class="link link-primary"
                                to="/datenschutz"
                            >
                                <span>
                                    {{
                                        $t(
                                            'footer.newsletter.inputLabels.privacyStatement'
                                        )
                                    }}
                                </span>
                            </RouterLink>
                            .*
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-card-foot is-justify-content-flex-end">
            <button
                :title="
                    !allRequiredFieldsAreFilled
                        ? $t('footer.newsletter.requiredFieldsMissing')
                        : ''
                "
                :disabled="!allRequiredFieldsAreFilled"
                class="button is-primary-dark px-6"
            >
                {{ $t('footer.newsletter.inputLabels.send') }}
                <SvgIcon
                    icon="icon--directional_arrow-right"
                    class="is-light ml-5"
                />
            </button>
        </div>
    </form>
</template>

<script>
import SvgIcon from '../svg/SvgIcon';
import axios from 'axios';
import convertToFormDataObject from '../../utilities/convert-to-form-data';
import { eventBus } from '../../events/event-bus';

export default {
    name: 'NewsletterForm.vue',
    props: ['mailFromParent'],
    components: { SvgIcon },
    data() {
        return {
            mail: '',
            contactDetails: {
                subject: 'Newsletteranmeldung',
                salutation: '',
                firstName: '',
                lastName: '',
                firm: '',
                street: '',
                plz: '',
                location: '',
                confirmation: false,
            },
            requiredFields: ['salutation', 'lastName', 'confirmation'],
            API_URL: 'https://3d-print.jomatik.de/rest_api',
        };
    },
    methods: {
        sendForm() {
            axios
                .post(
                    this.API_URL + '/ContactForm.php',
                    convertToFormDataObject(
                        Object.assign(
                            {},
                            this.contactDetails,
                            this.computedContactDetails
                        )
                    ),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    }
                )
                .then(() => {
                    eventBus.$emit('close-modal-event');
                    eventBus.notification({
                        type: 'success',
                        header: 'Newsletteranmeldung erfolgreich',
                        body: 'Ihre Anfrage wurde versendet. Sie werden in Kürze für den Newsletter angemeldet.',
                    });
                })
                .catch(function () {
                    eventBus.$emit('close-modal-event');
                    eventBus.notification({
                        type: 'warning',
                        header: 'Hier scheint ein Fehler aufgetreten zu sein.',
                        body: 'Ihre Newsletteranmeldung konnte nicht verarbeitet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    });
                });
        },
    },
    computed: {
        allRequiredFieldsAreFilled() {
            let result = true;
            this.requiredFields.forEach((value) => {
                if (!this.contactDetails[value]) {
                    result = false;
                }
            });
            if (!this.mail) {
                result = false;
            }
            return result;
        },
        computedContactDetails() {
            let str =
                'Es liegt eine neue Anmeldung für den Newsletter vor!\n\nName: ' +
                this.contactDetails.salutation +
                ' ' +
                this.contactDetails.firstName +
                ' ' +
                this.contactDetails.lastName +
                '\nFirma: ' +
                this.contactDetails.firm +
                '\nAdresse: ' +
                this.contactDetails.street +
                ', ' +
                this.contactDetails.plz +
                ' ' +
                this.contactDetails.location;
            return {
                message: str,
                mail: this.mail,
            };
        },
    },
    watch: {
        mailFromParent(value) {
            this.mail = value;
        },
    },
};
</script>

<style scoped></style>
